<div class="flex-column-start-start">
    <h2 [attr.id]="titleId" [id]="titleId" class="dark-title">
        {{ text }}
        <a *ngIf="withAnchor" [routerLink]="'.'" [fragment]="titleId">
            <mat-icon svgIcon="link" aria-hidden="false" aria-label="Link"></mat-icon>
        </a>
    </h2>
</div>
